export default __webpack_public_path__ + "static/media/car13.ec03264c.jpg";